import React from 'react';
import { i18n } from '../../i18n/translate.js';
import LoginLink from '../Modals/LoginLink.js';
import { HeaderMenu } from '../HeaderMenu.js';
import { Button } from '../Button/index.js';
var TopRightMenu = function TopRightMenu(_ref) {
  var _user$rule_sets;
  var adminifiDomain = _ref.adminifiDomain,
    authCapabilities = _ref.authCapabilities,
    authUrls = _ref.authUrls,
    content = _ref.content,
    contentLibrarySearch = _ref.contentLibrarySearch,
    customRight = _ref.customRight,
    helpMessage = _ref.helpMessage,
    helpMessageEnabled = _ref.helpMessageEnabled,
    hideLogin = _ref.hideLogin,
    hideMenu = _ref.hideMenu,
    homeroomDomain = _ref.homeroomDomain,
    idProvidersUrl = _ref.idProvidersUrl,
    isFoundry = _ref.isFoundry,
    isHomeroom = _ref.isHomeroom,
    isImpersonating = _ref.isImpersonating,
    isMobile = _ref.isMobile,
    languages = _ref.languages,
    loginText = _ref.loginText,
    menuData = _ref.menuData,
    onLoginLoad = _ref.onLoginLoad,
    onStopImpersonation = _ref.onStopImpersonation,
    selectedLanguage = _ref.selectedLanguage,
    socialIcon = _ref.socialIcon,
    user = _ref.user;
  var showLogin = !content && !hideLogin && (user === null || user === void 0 ? void 0 : user.guest);
  var showMenu = !(user !== null && user !== void 0 && user.guest) && !!menuData && !hideMenu && !content;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!customRight && /*#__PURE__*/React.createElement("ul", {
    className: "nav navbar-top-links navbar-right d-flex align-items-center",
    "aria-expanded": "false",
    dangerouslySetInnerHTML: {
      __html: customRight
    }
  }), contentLibrarySearch && !content && /*#__PURE__*/React.createElement("div", {
    className: "search-content-link"
  }, /*#__PURE__*/React.createElement(Button, {
    href: contentLibrarySearch,
    "aria-label": i18n.t('Search'),
    label: i18n.t('Search'),
    className: "capitalize with-border",
    "data-attribute": "content-search-button",
    "data-object-id": "content-search-btn",
    style: "secondary",
    branded: true,
    icon: "search"
  })), showLogin && /*#__PURE__*/React.createElement(LoginLink, {
    name: i18n.t('Login'),
    login_text: loginText,
    authCapabilities: authCapabilities,
    idProvidersUrl: idProvidersUrl,
    socialIcon: socialIcon,
    onLoginLoad: onLoginLoad,
    hideLogin: hideLogin
    /* @ts-ignore */,
    authUrls: authUrls
  }), showMenu && /*#__PURE__*/
  /* @ts-ignore */
  React.createElement(HeaderMenu, {
    adminifiDomain: adminifiDomain,
    currentRuleSets: (_user$rule_sets = user === null || user === void 0 ? void 0 : user.rule_sets) !== null && _user$rule_sets !== void 0 ? _user$rule_sets : [],
    helpMessage: helpMessage,
    helpMessageEnabled: helpMessageEnabled,
    homeroomDomain: homeroomDomain,
    isFoundry: isFoundry,
    isHomeroom: isHomeroom,
    isImpersonating: isImpersonating,
    isMobile: isMobile,
    languages: languages,
    menuData: menuData,
    onStopImpersonation: onStopImpersonation,
    organizationSlug: user === null || user === void 0 ? void 0 : user.organization_slug,
    selectedLanguage: selectedLanguage,
    user: user
  }));
};
TopRightMenu.displayName = 'TopRightMenu';
export { TopRightMenu as default };